import { Key } from '../utils/Helpers';

const r = () =>
    Math.random()
        .toString(36)
        .substr(2);

export default {
    props: {
        /**
         * @model
         */
        value: {
            default: '',
        },
        /**
         * Defines the size of the component
         * @values '', small, large
         */
        size: {
            type: String,
            default: '',
            validator: function(value) {
                return ['', 'small', 'large'].indexOf(value) >= 0;
            },
        },
        /**
         * Placeholder
         */
        placeholder: {
            type: String,
            default: '',
        },
        /**
         * Readonly
         */
        readonly: {
            type: Boolean,
            default: false,
        },
        /**
         * Disabled
         */
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            inputId: this.uid(),
            cssClass: {},
            rootHasFocus: false,
        };
    },
    watch: {
        size: {
            handler(val, valOld) {
                if (valOld) {
                    this.$delete(this.cssClass, `form-elem-${valOld}`);
                }
                if (val) {
                    this.$set(this.cssClass, `form-elem-${val}`, true);
                }
            },
            immediate: true,
        },
        readonly: {
            handler(val) {
                this.$set(this.cssClass, 'readonly events-none', val);
            },
            immediate: true,
        },
        disabled: {
            handler(val) {
                this.$set(this.cssClass, 'disabled', val);
            },
            immediate: true,
        },
        rootHasFocus(val) {
            this.$set(this.cssClass, 'focus', val);
        },
    },
    created() {
        window.addEventListener('blur', this.onWinBlur);
        document.addEventListener('mousedown', this.onDocMouseDown);
    },
    destroyed() {
        window.removeEventListener('blur', this.onWinBlur);
        document.removeEventListener('mousedown', this.onDocMouseDown);
    },
    methods: {
        uid() {
            return `${r()}-${r()}`;
        },
        getInputRef() {
            return document ? document.getElementById(this.inputId) : null;
        },
        onWinBlur(e) {
            this.rootHasFocus = false;
        },
        onDocMouseDown(e) {
            if (this.$el.contains(e.target)) {
                return;
            }
            this.rootHasFocus = false;
        },
        onInputKeydown(e) {
            if (e.key === Key.ESC && this.rootHasFocus) {
                e.stopPropagation();
                const el = this.getInputRef();
                if (el != null) {
                    el.blur()
                }
            }
        }
    },
};
